import { Cart } from '~/types/commercetools';

export const getLineItemFromSku = (cart: Cart, sku: string) => {
  return cart?.lineItems?.find(lineItem =>
    sku && lineItem.variant?.sku === sku);
};
